export const INVENTORY_MANUAL_MANAGEMENT_SUBSTEPS = Object.freeze({
  initialImport: 'initialImport',
  importResultAndInventorySync: 'importResultAndInventorySync',
  imsConnection: 'imsConnection',
});
